import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _51921d6e = () => interopDefault(import('../../../pages/_market/_lang/category/index.vue' /* webpackChunkName: "pages/_market/_lang/category/index" */))
const _538c8c9a = () => interopDefault(import('../../../pages/_market/_lang/product/index.vue' /* webpackChunkName: "pages/_market/_lang/product/index" */))
const _1e91dc78 = () => interopDefault(import('../../../pages/_market/_lang/category/_slug/index.vue' /* webpackChunkName: "pages/_market/_lang/category/_slug/index" */))
const _3c052c55 = () => interopDefault(import('../../../pages/_market/_lang/product/_slug/index.vue' /* webpackChunkName: "pages/_market/_lang/product/_slug/index" */))
const _31ff0cae = () => interopDefault(import('../../../pages/_market/_lang/category/_slug/constants.js' /* webpackChunkName: "pages/_market/_lang/category/_slug/constants" */))
const _6b992056 = () => interopDefault(import('../../../pages/_market/_lang/category/_slug/scripts.js' /* webpackChunkName: "pages/_market/_lang/category/_slug/scripts" */))
const _2eaeb138 = () => interopDefault(import('../../../pages/_market/_lang/product/_slug/scripts.js' /* webpackChunkName: "pages/_market/_lang/product/_slug/scripts" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/catalog/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/:market?/:lang?/category",
    component: _51921d6e,
    name: "market-lang-category"
  }, {
    path: "/:market?/:lang?/product",
    component: _538c8c9a,
    name: "market-lang-product"
  }, {
    path: "/:market?/:lang?/category/:slug",
    component: _1e91dc78,
    name: "market-lang-category-slug"
  }, {
    path: "/:market?/:lang?/product/:slug",
    component: _3c052c55,
    name: "market-lang-product-slug"
  }, {
    path: "/:market?/:lang?/category/:slug/constants",
    component: _31ff0cae,
    name: "market-lang-category-slug-constants"
  }, {
    path: "/:market?/:lang?/category/:slug/scripts",
    component: _6b992056,
    name: "market-lang-category-slug-scripts"
  }, {
    path: "/:market?/:lang?/product/:slug/scripts",
    component: _2eaeb138,
    name: "market-lang-product-slug-scripts"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
